import React from "react";

const CallToAction = () => {
  return (
    <div className="bg-cta py-20 sm:py-24 lg:py-48">
      <div className="container mx-auto text-center px-4 sm:px-8">
        <div className="bg-[#00000057] py-4 w-full sm:w-3/4 m-auto mb-4">
          <h2 className="text-2xl sm:text-4xl text-white uppercase mb-4">
            Free No-Obligation <br /> <strong>Consultation</strong>
          </h2>
          <p className="text-xl text-white w-full sm:w-1/2 mx-auto">
            <strong>
              Call:{" "}
              <a className="text-green-600" href="tel:800-816-1003">
                800-816-1003
              </a>
            </strong>{" "}
            to speak to a Texas Debt Specialist and ask about our Lowest Fee
            Guarantee
          </p>
        </div>
        <a
          className="transition duration-300 bg-green-700 hover:scale-110 px-12 text-white font-bold py-3 rounded uppercase"
          href="tel:800-816-1003"
        >
          Call Now
        </a>
      </div>
    </div>
  );
};

export default CallToAction;
